import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/useToast';
import Toast from '../components/Toast';
import './Auth.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { toasts, toast } = useToast();
  const from = location.state?.from?.pathname || '/dashboard';

  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); setErrors(e => ({ ...e, [k]: '', general: '' })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.email.trim()) errs.email = 'Email is required.';
    if (!form.password)     errs.password = 'Password is required.';
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    await new Promise(r => setTimeout(r, 600));
    const result = login(form.email, form.password);
    setLoading(false);

    if (result.ok) {
      toast(`Welcome back, ${result.user.name.split(' ')[0]}!`, 'success');
      setTimeout(() => navigate(from, { replace: true }), 500);
    } else {
      setErrors({ general: result.error });
    }
  };

  const fillDemo = (role) => {
    if (role === 'admin')  setForm({ email: 'admin@nextgenhub.tech', password: 'Admin@123' });
    if (role === 'client') setForm({ email: 'ravi@demo.com',    password: 'Demo@123' });
    setErrors({});
  };

  return (
    <>
      <Toast toasts={toasts} />
      <div className="auth-page">
        <div className="auth-left">
          <div className="auth-brand">
            <Link to="/" className="auth-logo">
              <div className="auth-logo-mark">NG</div>
              NextGenHub
            </Link>
          </div>
          <div className="auth-hero-text">
            <h2>Build products that move the needle.</h2>
            <p>Login to manage your projects, track your quotes, and collaborate with our team.</p>
          </div>
          <div className="auth-stats">
            {[['200+','Projects'],['98%','Satisfaction'],['7 yrs','Experience']].map(([n,l]) => (
              <div key={l} className="auth-stat">
                <div className="auth-stat-n">{n}</div>
                <div className="auth-stat-l">{l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="auth-right">
          <div className="auth-card">
            <h1>Welcome back</h1>
            <p className="auth-sub">Log in to your NextGenHub account</p>

            {/* Demo credentials */}
            <div className="demo-creds">
              <p className="demo-label">Quick demo access:</p>
              <div className="demo-btns">
                <button type="button" onClick={() => fillDemo('admin')}  className="demo-btn">Admin demo</button>
                <button type="button" onClick={() => fillDemo('client')} className="demo-btn">Client demo</button>
              </div>
            </div>

            <form onSubmit={handleSubmit} noValidate>
              {errors.general && <div className="auth-error">{errors.general}</div>}

              <div className="fg">
                <label>Email address</label>
                <input type="email" value={form.email} onChange={e => set('email', e.target.value)}
                  placeholder="you@company.com" className={errors.email ? 'error' : ''} autoComplete="email" />
                {errors.email && <div className="field-error">{errors.email}</div>}
              </div>

              <div className="fg pw-fg">
                <label>Password</label>
                <div className="pw-wrap">
                  <input type={showPw ? 'text' : 'password'} value={form.password}
                    onChange={e => set('password', e.target.value)}
                    placeholder="••••••••" className={errors.password ? 'error' : ''} autoComplete="current-password" />
                  <button type="button" className="pw-toggle" onClick={() => setShowPw(s => !s)}>
                    {showPw ? '🙈' : '👁'}
                  </button>
                </div>
                {errors.password && <div className="field-error">{errors.password}</div>}
              </div>

              <div className="auth-forgot">
                <Link to="/forgot-password">Forgot password?</Link>
              </div>

              <button type="submit" className="btn-grad auth-submit" disabled={loading}>
                {loading ? <><span className="spinner" /> Logging in…</> : 'Log in →'}
              </button>
            </form>

            <p className="auth-switch">
              Don't have an account? <Link to="/register">Create one →</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
